var map = {
	"./Dysrhythmia_Question1.jpg": 621,
	"./Dysrhythmia_Question10.jpg": 622,
	"./Dysrhythmia_Question2.jpg": 623,
	"./Dysrhythmia_Question3.jpg": 624,
	"./Dysrhythmia_Question4.jpg": 625,
	"./Dysrhythmia_Question5.jpg": 626,
	"./Dysrhythmia_Question6.jpg": 627,
	"./Dysrhythmia_Question7.jpg": 628,
	"./Dysrhythmia_Question8.jpg": 629,
	"./Dysrhythmia_Question9.jpg": 630,
	"./color_blind_image_1.jpg": 631,
	"./color_blind_image_10.jpg": 632,
	"./color_blind_image_2.jpg": 633,
	"./color_blind_image_3.jpg": 634,
	"./color_blind_image_4.jpg": 635,
	"./color_blind_image_5.jpg": 636,
	"./color_blind_image_6.jpg": 637,
	"./color_blind_image_7.jpg": 638,
	"./color_blind_image_8.jpg": 639,
	"./color_blind_image_9.jpg": 640,
	"./image_company.jpg": 319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 226;